module.exports = __webpack_public_path__ + "img/1787860.efdf9cdb.jpg";